// 表单规则
import { post } from "./axios";
import { t } from "../lang/i18n";
import Exp from "./Exp";
export default {
  // 注册手机
  regPhone: [
    { required: true, message: t("msg.m26"), trigger: "submit" },
    {
      validator: (rule, value, callback) => {
        if (!/^\d{5,}/.test(value)) return callback(new Error(t("msg.m27")));
        // 判断手机是否被使用
        post("/Member/RZJAuth/IsExistMobliePhone", {
          mobliePhone: value
        }).then(res => {
          if (res.IsExistMobliePhone) callback(new Error(t("msg.m69")));
          else callback();
        });
      },
      trigger: "blur"
    }
  ],
  // 注册邮箱
  regEmail: [
    { required: true, message: t("msg.m70"), trigger: "blur" },
    { type: "email", message: t("msg.m71"), trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        // 判断邮箱是否被使用
        post("/Member/RZJAuth/IsExistEmail", {
          email: value
        }).then(res => {
          if (res.err) return res.throw();
          if (res.IsExistEmail) callback(new Error(t("msg.m72")));
          else callback();
        });
      },
      trigger: "blur"
    }
  ],
  // 验证码
  code: [{ required: true, message: t("msg.m82"), trigger: "blur" }],
  // 邮箱
  email: [
    { required: true, message: t("msg.m70"), trigger: "blur" },
    { type: "email", message: t("msg.m71"), trigger: "blur" }
  ],

  //登录账号
  logAccount: [{ required: true, message: t("msg.m67"), trigger: "submit" }],

  //登录密码
  logPwd: [
    { required: true, message: t("msg.m32"), trigger: "submit" },
    {
      validator: (rule, value, callback) => {
        // 判断密码格式
        if (!Exp.password.test(value)) {
          callback(new Error(t("msg.m83")));
        } else {
          callback();
        }
      },
      trigger: "submit"
    }
  ],
  //登录手机号
  logPhone: [{ required: true, message: t("msg.m26"), trigger: "submit" }],
  // 重复登录密码
  logPwdAgain: [
    { required: true, message: t("msg.m32"), trigger: "submit" },
    {
      validator: (rule, value, callback) => {
        // 判断密码格式
        if (!Exp.password.test(value)) {
          return callback(new Error(t("msg.m83")));
        }
        // 判断密码是否相同
        if (this.phoneReLoginPswForm.password != value) {
          callback(new Error(t("msg.m31")));
        } else {
          callback();
        }
      },
      trigger: "submit"
    }
  ],
  // 密码使用时
  pwdUse: [
    { required: true, message: t("msg.m32"), trigger: "submit" },
    { min: 8, max: 16, message: t("msg.m133"), trigger: "submit" },
    {
      validator: (rule, value, callback) => {
        // 判断密码格式
        if (!Exp.password.test(value)) {
          callback(new Error(t("msg.m133")));
        } else {
          callback();
        }
      },
      trigger: "submit"
    }
  ],
  // 银行卡号
  cardNumber: [{ required: true, message: t("msg.m85"), trigger: "submit" }],
  // 检查为空
  empty(msg) {
    return [
      { required: true, message: msg || t("msg.m86"), trigger: "submit" }
    ];
  }
};
